import React, { useState } from 'react'
import { PlusOutlined } from '@ant-design/icons';
import { SketchPicker } from 'react-color';
import { Modal, Button, Divider } from 'antd';

export default function SiloBackgroundColor(props) {
  
    const [showColorModal, setShowColorModal] = useState(false);
    const [customColor, setCustomColor] = useState("#CCCCCC");

    return (
        <>
            <div>
                <span className='manrope f-14 black silo-heading-main'>
                    Background
                </span>
                <div className='silo-background-radio' style={{display:"flex", flexWrap:"wrap", marginTop:"3%"}} value={props.backgroundColor} onChange={props.changeBackgroundColor} defaultValue={0} buttonStyle="solid">
                    {
                        props.allBackgroundColors.map((color, index) => {
                            return <div className={ props.hexColor == "default" ? (index == 0 ? "silo-background-bordered":"silo-background-not-bordered" ) : (color == props.hexColor ? "silo-background-bordered":"silo-background-not-bordered" ) } onClick={() => {props.setHexColor(color)}} value={index} style={{width:"3vw", height:"3vw", background:color, borderRadius:"3vw", marginLeft:"6px", marginTop:"6px"}} />
                        })
                    }
                    <div onClick={() => setShowColorModal(true)} style={{width:"3vw", height:"3vw", borderRadius:"3vw", marginLeft:"6px", textAlign:"center", padding:"1vw 0px", border:"solid 1px black", cursor:"pointer", marginTop:"6px"}} className='manrope f-10'>
                        <PlusOutlined/>
                        Add
                    </div>
                    
                </div>
            </div>
            <Modal 
                footer = {false}
                onCancel={() => setShowColorModal(false)}
                visible={showColorModal} >
                <div>
                    <span className='manrope f-16'>
                        Choose Custom Background Color
                    </span>
                </div>
                <Divider/>
                
                <div className="overflow-hidden">
                    <SketchPicker
                    onChange={(color) => {
                        setCustomColor(color.hex);
                    }}
                    width="fit-content"
                    color={customColor}
                    presetColors={[]}
                    disableAlpha = {true}
                    />
                </div>
                <Divider/>
                <div>
                    <Button 
                    onClick={() => {
                        let backgroundColors = props.allBackgroundColors;
                        backgroundColors.push(customColor);
                        props.setAllBackgroundColors(backgroundColors);
                        props.setHexColor(customColor);
                        setShowColorModal(false);
                    }} 
                    className="modal-okay-blue square font-14">
                        Add
                    </Button>
                </div>
            </Modal>
        </>
  )
}
